import { useParams } from 'react-router-dom'
import StatusDetails from './components/StatusDetails'
import StatusAdd from './components/StatusAdd'

const StatusNew = () => {
  const { id: _id, show } = useParams()
  if (_id && show === 'show') return <StatusDetails />
  return <StatusAdd />
}

export default StatusNew
